<template>
  <div class="pdf-order-section">
    <div class="text-h1 color-light">
      Плательщик
    </div>
    <vz-col col="6" md="6" sm="12" class="p-0 vz-position-relative">
      <div v-if="orderLockState.payer && !isCloned" class="disabled-card" />
      <vz-switcher
        v-model="payer"
        class="text-caption vz-order-network-payer-switcher my-20"
        big
        :disabled="orderLockState.payer && !isCloned"
        :items="payers"
      />
    </vz-col>
  </div>
</template>

<script setup lang="ts">
import {SwitchItem} from '~/types/types';
import useOrderPayer from '~/components/personal/order/payer/useOrderPayer';

const payers: SwitchItem[] = [
  {
    title: 'Отправитель',
    value: 'dispatch'
  },
  {
    title: 'Получатель',
    disabled: true,
    disabledText: 'Получатель не может быть плательщиком',
    value: 'destination'
  },
  {
    title: 'Третье лицо',
    value: 'third'
  }
]

const {orderLockState, isCloned, payer } = useOrderPayer()
</script>

<style lang="scss">
.vz-order-network-payer-switcher {
  .vz-switcher-item {
    padding: 10px 5px !important;
  }
}
</style>
